import { render, staticRenderFns } from "./PlanQuotaItem.vue?vue&type=template&id=d8b44d38&scoped=true&"
import script from "./PlanQuotaItem.vue?vue&type=script&lang=js&"
export * from "./PlanQuotaItem.vue?vue&type=script&lang=js&"
import style0 from "./PlanQuotaItem.vue?vue&type=style&index=0&id=d8b44d38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8b44d38",
  null
  
)

/* custom blocks */
import block0 from "./PlanQuotaItem.vue?vue&type=custom&index=0&blockType=i18n&locale=ru&lang=yml"
if (typeof block0 === 'function') block0(component)
import block1 from "./PlanQuotaItem.vue?vue&type=custom&index=1&blockType=i18n&locale=en&lang=yml"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
